// src/pages/firm/role/FirmRoleList.tsx
import React, { useState } from "react";
import { EDataTable } from "../../../components/EDataTable";
import { IconButton, IconTextButton } from "../../../components/ButtonComponents";
import { TableActions } from "../../../components/TableActions";
import { Edit, ShieldPlus, Trash2, ShieldAlert } from "lucide-react";
import { FirmRoleDialog } from "./FirmRoleDialog";
import { useRoleStore } from "../../../store/roleStore";
import { toast } from "react-toastify";
import { DataTableColumn, SimpleFilter } from "../../../types";
import { useConfirmModal } from "../../../hooks/useConfirmModal"; // Hook'u import ettik
import { getTurkishRoleName, RoleType } from "../../../types/role";

export const FirmRoleList = () => {
  const store = useRoleStore();
  const { confirm, modal } = useConfirmModal(); // Hook'u başlattık
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState<any>(null);

  const handleSave = async (data: any) => {
    try {
      if (selectedRole) {
        await store.updateItem(selectedRole.id, data);
        toast.success("Rol başarıyla güncellendi");
      } else {
        await store.createItem(data);
        toast.success("Yeni rol başarıyla tanımlandı");
      }
      setIsModalOpen(false);
    } catch (e) {
      toast.error("İşlem başarısız");
    }
  };

  const handleDelete = async (id: number) => {
    // Projenin kendi confirm modal'ını tetikliyoruz
    const isConfirmed = await confirm(
      "Bu rolü silmek istediğinize emin misiniz? Bu işlem geri alınamaz ve bu role sahip kullanıcıları etkileyebilir.",
      "Rol Silme Onayı"
    );

    if (isConfirmed) {
      try {
        await store.deleteItem(id);
        toast.success("Rol başarıyla silindi");
      } catch (e) {
        toast.error("Silme işlemi sırasında bir hata oluştu");
      }
    }
  };

  const columns: DataTableColumn<RoleType>[] = [
    { 
      field: "name", 
      header: "Rol Adı", 
      sortable: true,
      width: "250px",
      body: (row: any) => (
        <div className="flex items-center gap-2 justify-between">
          <span className="font-semibold  ">{ getTurkishRoleName(row.name ) || ""}</span>
          {row.firmId === null && (
            <span className="text-[9px]   px-1.5 py-0.5 card2">
              Sistem
            </span>
          )}
        </div>
      )
    },
    { 
      field: "permissions", 
      header: "Yetki Durumu", 
      width: "150px",
      align: "center",
      body: (row: any) => (
        <span className={`px-2 py-1 rounded-md text-xs font-bold ${row.permissions?.length > 0 ? 'bg-indigo-50 text-indigo-600' : 'bg-gray-50  text-gray-800'}`}>
          {row.permissions?.length || 0} Yetki
        </span>
      )
    },
    {
      field: "actions",
      header: "İşlemler",
      width: "120px",
      align: "center",
      body: (row: any) => {
        const isSystemRole = row.firmId === null;

        return (
          <TableActions
            actions={[
              {
                icon: Edit,
                colorClass: isSystemRole ? "text-amber-500 hover:bg-amber-50" : "text-blue-600 hover:bg-blue-50",
                title: isSystemRole ? "Görüntüle" : "Düzenle",
                onClick: () => { setSelectedRole(row); setIsModalOpen(true); }
              },
              {
                icon: Trash2,
                colorClass: "text-red-600 hover:bg-red-50",
                title: "Sil",
                onClick: () => handleDelete(row.id),
                show: !isSystemRole
              },
              {
                icon: ShieldAlert,
                colorClass: "text-gray-300 cursor-not-allowed",
                title: "Sistem rolleri silinemez",
                onClick: () => {},
                show: isSystemRole
              }
            ]}
          />
        );
      }
    }
  ];

  return (
    <div className="p-4">
      <EDataTable
      tableKey="firm_role_list"
        useStore={() => store}
        title="Firma Rol Yönetimi"
        columns={columns as any}
        dataKey="id"
        placeholder="Rol adı ile ara..."
        searchFields={[
          { field: "name", operator: "contains" }
        ]}
        actions={
          <IconTextButton 
            icon={ShieldPlus} 
            onClick={() => { setSelectedRole(null); setIsModalOpen(true); }} 
            className="btn-new"
          >
            Yeni Rol Tanımla
          </IconTextButton>
        }
      />
      
      <FirmRoleDialog 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        role={selectedRole} 
        onSave={handleSave} 
      />

      {/* useConfirmModal'dan gelen modal'ı render ediyoruz */}
      {modal}
    </div>
  );
};